class BuyScroller {
  constructor(buttonSelector = '.buy-scroller__button', targetSelector = '.quantity-buy-container') {
    this.button = document.querySelector(buttonSelector);
    this.target = document.querySelector(targetSelector);

    if (this.button && this.target) {
      this.button.addEventListener('click', (e) => this.scrollToTarget(e));
    }
  }

  scrollToTarget(e) {
    e.preventDefault();

    const targetRect = this.target.getBoundingClientRect();
    const absoluteElementTop = window.pageYOffset + targetRect.top;
    const offset = absoluteElementTop - (window.innerHeight - targetRect.height);

    window.scrollTo({
      top: offset + 70,
      behavior: 'smooth',
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new BuyScroller();
});
